import {
  WordLengthFilter,
  CombinedWordLengthFilter,
  NumWordsFilter,
  WordBalanceFilter,
  AdjacentLetterFilter,
  AlliterationFilter,
  SameEndLetterFilter,
  FrequencyFilter,
} from './wordstats';
import {SlugRegistry} from '@/domainproject/registry';
import {FilterJson, Filter} from '../filter';
import {
  KeywordFilter,
  RegularExpressionWordFilter,
  RegularExpressionOverallFilter,
} from './keyword';
import {
  RangeParameter,
  NullableRangeParameter,
  KeywordParameter,
  Parameter,
  ParamJson,
} from '../parameter';
import {$_COLORS} from '../colors';

export const $_FILTERS = new SlugRegistry(
  [
    KeywordFilter,
    WordLengthFilter,
    CombinedWordLengthFilter,
    NumWordsFilter,
    WordBalanceFilter,
    AdjacentLetterFilter,
    AlliterationFilter,
    SameEndLetterFilter,
    FrequencyFilter,
    RegularExpressionWordFilter,
    RegularExpressionOverallFilter,
  ],
  filter => filter.$_title
);

export const $_PARAMS = new SlugRegistry(
  [RangeParameter, NullableRangeParameter, KeywordParameter],
  param => param.$_kind
);

export function deserializeFilter(json: FilterJson): Filter {
  const filter = new ($_FILTERS.get(json.title))();
  filter.$_params = json.params.map(param => deserializeParameter(param)) as any;
  filter.$_color = $_COLORS.get(json.color);
  filter.$_power = json.power;
  filter.$_scale = json.scale;
  filter.$_inv = json.inv;
  filter.$_firstWord = json.firstWord;
  filter.$_middleWords = json.middleWords;
  filter.$_lastWord = json.lastWord;

  return filter;
}

export function deserializeParameter(json: ParamJson<any>): Parameter {
  return ($_PARAMS.get(json.kind) as any).deserialize(json as any);
}
